import React, { useState, useEffect, useRef, useMemo } from 'react'
import styled from 'styled-components';
import logo from '../../images/MegaPlazaBuilding.jpg';
import { delay } from '../../utils/delay';
import { addLocation, editLocation } from '../../redux/locationSlice';
import { useDispatch } from 'react-redux';
import { currentDateLocale } from '../../utils/currentDate';
import { useSelector } from 'react-redux';
import { mobile } from '../../responsive';

const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url(${logo})
      center;
      
  background-size: cover;
`

const Wrapper = styled.div`
    width: 60vw;
    background-color: white;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);

    ${mobile({
        width: '70vw',
    })};
`

const Title = styled.h1`
    text-decoration: underline;
    text-decoration-color: gray;
    text-underline-offset: 6px;
    margin: 5px;
    text-align: center;
`

const SubTitle = styled.h1`
    color: red;
    margin: 5px;
    font-size: 15px;
    
`

const Form = styled.div`
    display: flex;
    flex-direction: column;
`

const FormRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5px;

    ${mobile({
        flexWrap: 'wrap',
        justifyContent: 'center',
    })};
`

const FormColumn = styled.div`

`

const FormLabel = styled.h1`
    font-size: 20px;
    font-weight: 300;
    margin: 5px;
    padding: 10px;
    
     ${mobile({
         textAlign: 'center'
     })}
`

const FormInput = styled.input`
    padding: 10px;
    margin: 5px;
    font-size: 20px;
    width: 300px;

    border-radius: 5px;
    border: none;
   
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
     &:hover, &:focus {
         box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                 -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
   
     }
    ${mobile({
        width: '60vw'
    })};
`

const Button = styled.button`
    padding: 10px 20px;
    margin: 30px 20px;
    border-radius: 10px;
    color: white;
    background: rgba(0, 200, 200, 0.9);
    cursor: pointer;
    border: none;
    font-size: 20px;
    font-weight: bold;
    box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                inset 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                inset -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    
    &:hover{
        box-shadow: none;
    }
`

const FormMessageBox = styled.h1`
    height: 20px;
    font-size: 20px;
    margin: 0;
    visibility: ${props => props?.messageType ? 'visible' : 'hidden'};
    color: ${props => props?.messageType === 1 ? 'green' : 'red'};
`

const Location = ({locationIdToEdit}) => {

    //console.log(locationIdToEdit);
    const initialState = {
        'locationId' : '',
        'locationName' : '',
        'locationDesc' : '',
        'locationHead' : '',
        'updatedDate' : '',
        'createdDate' : ''
    };
    const [location, setLocation] = useState(initialState);
    const [formMessage, setFormMessage] = useState({});
    const [edit, setEdit] = useState(false);
    const dispatch = useDispatch();
    const locationRedux = useSelector(state => state.locationRedux);
    const formRef = useRef();
    const locations = useMemo(() => [...locationRedux?.locations], [locationRedux?.locations]);
    

    const clearState = () => {
        setLocation({...initialState});
        setEdit(false);
    };

    useEffect(() => {

        if(locationIdToEdit && locationIdToEdit.locationId && Number(locationIdToEdit.locationId) > 0){
            setEdit(true);
            const editLocation = locations?.filter((item) => item.locationId === Number(locationIdToEdit.locationId));
            if(editLocation && editLocation[0]){
                setLocation(editLocation[0]);
            }
            
        }

        if(formRef.current){
            formRef.current.scrollIntoView({
                behavior: 'smooth',
            });
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ locationIdToEdit]);

    const handleFormInput = (e) => {
        const {name, value} = e.target;
        setLocation({...location, [name]: value});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Create Location Clicked');
        if (location?.locationName && location?.locationDesc) {
            console.log('No Errors');
            
            if(edit){
                await dispatch(
                    editLocation({
                        ...location, 
                        'updatedDate': currentDateLocale(),
                    })
                );
            }
            else{
                await dispatch(
                    addLocation({
                        ...location,
                        'locationId' : getNextAvailableId(), 
                        'createdDate': currentDateLocale(),
                    })
                );
            }
            
            await clearState();
            setFormMessage({'type' : 1, 'message' : 'Location Saved Successfully'});
            //setLocation({});

        } 
        else{
            console.log('Has Errors');
            setFormMessage({'type' : 2, 'message' : 'Some required fields are not filled'});
        }

        await delay(5000);

        setFormMessage({});

    }

    const getNextAvailableId = () => {
        return locationRedux && locationRedux.locations && locationRedux.locations.length > 0 
            ? locationRedux.locations[locationRedux.locations.length - 1].locationId + 1 : 1;
    };

    return (
        <Container ref={formRef}>
            <Wrapper>
                <Title>
                    {edit ? 'Edit Location' : 'Create New Location'}
                </Title>
                <SubTitle>
                    * == required
                </SubTitle>
                <FormMessageBox messageType={formMessage?.type}>
                    {formMessage?.message}
                </FormMessageBox>
                <Form>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Location Name*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='locationName'
                                        placeholder= 'Enter Location Name'
                                        value = {location.locationName}
                                        onChange = {(e) => handleFormInput(e)} 

                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Location Description*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='locationDesc'
                                        placeholder='Enter Location Description'
                                        value={location.locationDesc}
                                        onChange={(e) => handleFormInput(e)}
                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Location Head
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='locationHead'
                                        placeholder='Enter Location Head'
                                        value={location.locationHead}
                                        onChange={(e) => handleFormInput(e)} />
                            
                        </FormColumn>
                    </FormRow>
                </Form>
                <Button onClick={(e) => handleSubmit(e)}>
                    {edit ? 'Edit Location' : 'Create Location'}
                </Button>
            </Wrapper>
        </Container>
    )
}

export default Location
